import { createContext, useEffect, useRef, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Bounce, toast } from 'react-toastify';
import { apiJalles, urlWebSockt } from '../services/api';
import { io } from 'socket.io-client';

export const HomeContext = createContext({});

export const HomeProvider = () => {
  const navigate = useNavigate();

  const [user, setUser] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [userOn, setUserOn] = useState({});
  const [modalAvisoOpen, setModalAvisoOpen] = useState(false);

  const reconnectAttempts = useRef(0);
  const MAX_RECONNECT_ATTEMPTS = 2;

  const [loading, setLoading] = useState(false);
  const [socket, setSocket] = useState(null);
  const token = sessionStorage.getItem('connectionsToken');

  const headerApi = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    if (!token) {
      sessionStorage.clear();
      navigate('/login');
    }
  }, []);

  useEffect(() => {
    const newSocket = io(urlWebSockt, {
      path: '/67ZlfPVt/socket.io',
      auth: {
        token: token,
      },
      transports: ['websocket', 'polling'],
      reconnectionAttempts: MAX_RECONNECT_ATTEMPTS,
      reconnectionDelay: 2000,
    });

    let usuarioSave;
    setSocket(newSocket);

    newSocket.on('connect', () => {
      reconnectAttempts.current = 0;
      console.log('WebSocket connected');
    });

    newSocket.on('user_data', (userData) => {
      // console.log("user_data received:", userData);
      setUser(userData);
      setTimeout(() => (usuarioSave = userData), 1000);
    });

    newSocket.on('user_updated', (userData) => {});

    newSocket.on('changed_user', (userId) => {
      setUserOn(userId);
    });

    newSocket.on('User_desconectado_sessao', (userId) => {
      if (usuarioSave && usuarioSave.id === userId) {
        sessionStorage.clear();
        navigate('/login');

        toast.warn('Usuário desconectado!', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark',
          transition: Bounce,
        });
      }
    });

    newSocket.on('connect_error', (err) => {
      // Exibe uma mensagem mais amigável se a propriedade 'data' estiver disponível
      reconnectAttempts.current += 1;
      if (reconnectAttempts.current >= MAX_RECONNECT_ATTEMPTS) {
        sessionStorage.clear();
        navigate('/login');

        const mensagem =
          err.data?.message === 'Invalid token'
            ? 'Sessão expirada'
            : 'Falha ao conectar com o servidor';

        toast.warn(mensagem, {
          position: 'top-right',
          autoClose: 5000,
          theme: 'dark',
          transition: Bounce,
        });
      } else {
        console.warn('Tentativa de reconexão:', reconnectAttempts.current);
        if (err.message == 'Invalid token') {
          sessionStorage.clear();
          navigate('/login');
          const mensagem = 'Sessão expirada';
          toast.warn(mensagem, {
            position: 'top-right',
            autoClose: 5000,
            theme: 'dark',
            transition: Bounce,
          });
        }
      }
    });

    return () => {
      newSocket.disconnect();
    };
  }, [token]);

  return (
    <HomeContext.Provider
      value={{
        user,
        navigate,
        isOpen,
        setIsOpen,
        socket,
        userOn,
        headerApi,
        modalAvisoOpen,
        setModalAvisoOpen,
        headerApi,
      }}
    >
      <Outlet />
    </HomeContext.Provider>
  );
};
